import { createSingleInterpolatedTranslationKey, dateFormatter } from '@dreryk/react-common';
import { SecondaryText } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';

type SubtitleSlotProps = {
   readonly hasData: boolean;
   readonly lastUpdateDate?: Date;
};

export const SubtitleSlot = (props: SubtitleSlotProps): JSX.Element => {
   if (!props.hasData) {
      return <SecondaryText testId={'subtitle'} text={appointmentsTranslationKeys.medicalProfile.subtitle.noData} />;
   }

   if (props.lastUpdateDate) {
      return (
         <SecondaryText
            testId={'subtitle'}
            text={createSingleInterpolatedTranslationKey(
               appointmentsTranslationKeys.medicalProfile.subtitle.lastUpdate,
               'date',
               dateFormatter(props.lastUpdateDate)
            )}
         />
      );
   }

   return <SecondaryText testId={'subtitle'} />;
};
